module.exports = __webpack_public_path__ + "img/92193f5.png";